// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectSnapshotMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_GET_SNAPSHOT_RESPONSE);
        this.UserId = NaN;
        this.RouteId = NaN;
        this.TradableId = NaN;
        this.Bid = NaN;
        this.BidSize = NaN;
        this.Ask = NaN;
        this.AskSize = NaN;
        this.Last = NaN;
        this.LastSize = NaN;
        this.High = NaN;
        this.Low = NaN;
        this.Close = NaN;
        this.Volume = NaN;
        this.ReceivedAt = new Date(); // дата создания сообщения
    }
}
